import { FC, useState } from 'react'
import { SiteModel } from '../../../core/_models'
type Props = {
  site: SiteModel
}
const CurrencyRateCell: FC<Props> = ({ site }) => (

  <div className='d-flex align-items-center'>
    {site.currencyRateEurTry1}
  </div>

)
export { CurrencyRateCell }
